import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { orgHandlesMatch } from '~hooks/useUrlOrganizationHandle'
import { type RootState } from '~redux/rootReducer'
import { setSelectedEIOrganization } from '~redux/slices/organizationSlice'

const LEGACY_SETTINGS_SECTIONS = new Map<string, string>([
  ['general', 'details'],
  ['payments', 'payments'],
  ['tags', 'tags'],
  ['sso', 'sso'],
  ['email_domains', 'email-domains'],
  ['data_retention', 'data-retention'],
  ['assistant_logs', 'assistant-logs'],
  ['access-controls', 'users'],
  ['ai-skills', 'ai-skills'],
])

interface LegacySettingsRedirectProps {
  section?: string
}

const LegacySettingsRedirect = ({ section }: LegacySettingsRedirectProps): null => {
  const { organizationHandle, settingType } = useParams<{
    organizationHandle?: string
    settingType?: string
  }>()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { search } = useLocation()
  const emailIdentities = useSelector((state: RootState) => state?.organization.emailIdentities)
  const selectedOrganization = useSelector(
    (state: RootState) => state?.organization.selectedOrganization,
  )
  const hubSection =
    section ?? (settingType ? LEGACY_SETTINGS_SECTIONS.get(settingType) : undefined)

  useEffect(() => {
    if (organizationHandle) {
      const organization = emailIdentities?.find((identity) =>
        orgHandlesMatch(identity.handle, organizationHandle),
      )
      if (organization && organization.id !== selectedOrganization?.id) {
        dispatch(setSelectedEIOrganization(organization))
      }
    }

    navigate(`${hubSection ? `/settings-hub/${hubSection}` : '/settings-hub'}${search}`, {
      replace: true,
    })
  }, [
    dispatch,
    emailIdentities,
    hubSection,
    navigate,
    organizationHandle,
    search,
    selectedOrganization?.id,
  ])

  return null
}

export default LegacySettingsRedirect
